// Written by scripts/bundle_static.py at deploy time — do not edit.
export const BUILD_ID = 'v20260917-0805';
